// CustomNotificationContent.js
import React from 'react';
import NotificationSnackbarLayout from '../common/NotificationSnackbarLayout';
import { notificationTriggerLabel } from '../notificationShared';

const CustomNotificationContent = React.forwardRef((props, ref) => {
  const { message, closeSnackbar } = props;
  const notification = message;

  const isUnread = !notification?.isRead;
  const primaryLine = notificationTriggerLabel(notification?.triggeredBy);
  const secondaryLine = notification?.projectName ?? '';

  return (
    <NotificationSnackbarLayout
      ref={ref}
      closeSnackbar={closeSnackbar}
      isUnread={isUnread}
      avatarSrc={notification?.triggeredBy?.avatarUrl || '/images/user.png'}
      avatarChildren={
        notification?.triggeredBy?.firstName
          ? notification.triggeredBy.firstName.charAt(0)
          : ''
      }
      primaryLine={primaryLine}
      secondaryLine={secondaryLine}
      bodyText={notification?.changes || 'No changes text'}
      captionDate={new Date(notification?.createdAt || Date.now()).toLocaleString()}
    />
  );
});

CustomNotificationContent.displayName = 'CustomNotificationContent';
export default CustomNotificationContent;
